import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import DashboardHeader from '../components/common/DashboardHeader';
import ReportsHub from '../components/reports/ReportsHub';
import { detectThemeSync, watchThemeChanges } from '../utils/themeUtils';
import { getDashboardPageShellSx } from '../utils/dashboardSurfaceSx';
import { isMobileShellLayout } from '../utils/mobileShellLayout';

const ReportsPage = () => {
  const [currentTheme, setCurrentTheme] = useState(() => detectThemeSync());

  useEffect(() => {
    return watchThemeChanges(setCurrentTheme);
  }, []);

  return (
    <Box sx={getDashboardPageShellSx(currentTheme)}>
      <DashboardHeader
        title="Reports"
        forceDark={isMobileShellLayout()}
        breadcrumbs={[
          { label: 'Home', path: '/dashboard/' },
          { label: 'Finance', path: '/finance/' },
          { label: 'Reports' },
        ]}
        navLinks={[
          { url: '/finance/', label: 'Finance Dashboard' },
          { url: '/finance/payments/', label: 'Payment List' },
          { url: '/finance/expenses/', label: 'Expenses' },
        ]}
      />
      <ReportsHub />
    </Box>
  );
};

export default ReportsPage;
